import { useEffect, useState, useContext } from "react";
import './../../index.css'
import systemContext from "../../_context/systemContext";
import { Modal, Spinner } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { vscService } from "../../_services/vscService";
import { FaEdit, FaTrash, FaPlus, FaCalendarAlt } from "react-icons/fa";
import { Tooltip } from 'react-tooltip';
import ReglaModal from "./Modales/ModalReglas";
import '../../DataTable.css';
import Swal from 'sweetalert2';

const ReglasDescuento = () => {
    const SystemContext = useContext(systemContext);
    const user = SystemContext.getUser();
    const [datos, setDatos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filterText, setFilterText] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [reglaEdit, setReglaEdit] = useState(null);
    const [modalLoading, setModalLoading] = useState(false);
    const estatusOptions = [
        { value: 'Activa', label: 'Activa' },
        { value: 'Inactiva', label: 'Inactiva' }
    ];

    const columns = [
        {
            name: 'ID',
            selector: row => row.idRegla,
            sortable: true,
            width: '80px',
            wrap: true
        },
        {
            name: 'Título',
            selector: row => row.titulo,
            sortable: true,
            wrap: true,
            minWidth: '220px'
        },
        {
            name: 'Regla',
            selector: row => row.regla,
            sortable: false,
            wrap: true,
            cell: row => (
                <div style={{ maxWidth: 420, whiteSpace: 'normal' }}>
                    <small>{row.regla}</small>
                </div>
            )
        },
        {
            name: 'Porcentaje',
            selector: row => (row.porcentaje != null ? `${parseFloat(row.porcentaje).toString()}%` : ''),
            sortable: true,
            width: '120px',
            cell: row => <strong>{row.porcentaje != null ? `${parseFloat(row.porcentaje).toString()}%` : '-'}</strong>
        },
        {
            name: 'Vigencia',
            selector: row => `${formatDate(row.vigenciaInicio)} → ${formatDate(row.vigenciaFin)}`,
            sortable: true,
            width: '220px'
        },
        {
            name: 'Estatus',
            selector: row => row.estatus,
            sortable: true,
            width: '120px'
        },
        {
            name: 'Acciones',
            cell: row => (
                <div className="nova-grid-actions">
                    <button 
                        className="nova-btn-action nova-btn-edit"
                        onClick={() => handleEdit(row)}
                        data-tooltip-id="edit-tooltip"
                        data-tooltip-content="Editar regla"
                    >
                        <FaEdit className="nova-action-icon" />
                    </button>
                    <button 
                        className="nova-btn-action nova-btn-delete"
                        onClick={() => handleDelete(row.idRegla)}
                        data-tooltip-id="delete-tooltip" 
                        data-tooltip-content="Eliminar regla"
                    >
                        <FaTrash className="nova-action-icon" />
                    </button>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '120px',
        },
    ];

    // Formatea fecha yyyy-mm-dd a dd/mm/yyyy
    const formatDate = (d) => {
        if (!d) return '';
        const dt = new Date(d);
        if (isNaN(dt)) return d;
        const dd = String(dt.getDate()).padStart(2, '0');
        const mm = String(dt.getMonth() + 1).padStart(2, '0');
        const yy = dt.getFullYear();
        return `${dd}/${mm}/${yy}`;
    };

    const filteredItems = datos.filter(item => {
        const text = filterText.trim().toLowerCase();
        if (!text) return true;
        return (
            (item.Titulo || '').toString().toLowerCase().includes(text) ||
            (item.Regla || '').toString().toLowerCase().includes(text) ||
            (item.Porcentaje != null && item.Porcentaje.toString().toLowerCase().includes(text)) ||
            (item.Estatus || '').toString().toLowerCase().includes(text) ||
            (item.IdRegla != null && item.IdRegla.toString().includes(text))
        );
    });

    const customStyles = {
        headRow: {
            style: {
                backgroundColor: 'var(--primary-color)',
                color: 'white',
                fontSize: '0.9rem',
                fontWeight: '600',
                minHeight: '50px',
                borderBottom: '2px solid rgba(255, 255, 255, 0.3)',
            },
        },
        headCells: {
            style: {
                paddingLeft: '12px',
                paddingRight: '12px',
                fontSize: '0.85rem',
                fontWeight: '600',
            },
        },
        cells: {
            style: {
                paddingLeft: '10px',
                paddingRight: '10px',
                fontSize: '0.75rem',
                color: 'var(--text-dark)',
            },
        },
        rows: {
            style: {
                fontSize: '0.75rem',
                minHeight: '32px',
                '&:nth-child(even)': {
                    backgroundColor: 'rgba(0, 50, 139, 0.02)',
                },
                '&:hover': {
                    backgroundColor: 'rgba(0, 50, 139, 0.05) !important',
                },
            },
            stripedStyle: {
                backgroundColor: 'rgba(0, 50, 139, 0.02)',
            },
        },
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    const subHeaderComponent = (
        <div className="nova-table-search">
            <input
                type="text"
                placeholder="Buscar por título, regla, porcentaje, estatus..."
                className="nova-search-input"
                value={filterText}
                onChange={e => setFilterText(e.target.value)}
            />
            <div className="nova-search-results">
                {filteredItems.length} de {datos.length} registros
            </div>
        </div>
    );

    const NoDataComponent = () => (
        <div className="nova-no-data">
            <div className="nova-no-data-icon">📋</div>
            <h3>No se encontraron reglas</h3>
            <p>No hay reglas registradas en el sistema.</p>
            <button className="nova-btn-primary" onClick={handleAddNew}>
                <FaPlus className="me-2" />
                Agregar Primera Regla
            </button>
        </div>
    );

    useEffect(() => {
        getReglas();
    }, []);

    const getReglas = async () => {
        try {
            setLoading(true);
            const respuesta = await vscService.getReglasDescuento();
            if (respuesta.status === "OK") {
                const datosResp = respuesta.content?.reglas || respuesta.content?.data || respuesta.data || [];
                setDatos(datosResp);
            } else {
                throw new Error(respuesta.message || 'Error al cargar reglas');
            }
        } catch (error) {
            console.error('Error en obtener reglas:', error);
            setDatos([]);
            await Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Error al cargar las reglas.",
                text: error.message || "Por favor, intenta nuevamente.",
                showConfirmButton: false,
                timer: 2000,
                customClass: { popup: 'nova-swal-popup' }
            });
        } finally {
            setLoading(false);
        }
    };

    // Handlers
    const handleAddNew = () => {
        setReglaEdit(null);
        setShowModal(true);
    };

    const handleEdit = (regla) => {
        setReglaEdit({
            ...regla,
            // Asegura que porcentaje sea string/number legible por el modal
            porcentaje: regla.porcentaje != null ? regla.porcentaje.toString() : ''
        });
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        const regla = datos.find(r => r.idRegla === id);
        const result = await Swal.fire({
            title: '¿Estás seguro?',
            text: `¿Deseas eliminar la regla "${regla?.titulo}"? Esta acción no se puede deshacer.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            customClass: {
                popup: 'nova-swal-popup',
                confirmButton: 'nova-swal-confirm',
                cancelButton: 'nova-swal-cancel'
            }
        });
        if (result.isConfirmed) {
            setLoading(true);
            console.log("id a eliminar:", id);
            try {
                const resultado = await vscService.delEliminaReglaDescuento(id); // debes implementar
                // adapta la comprobación según tu API (status, success, statusText, etc.)
                if (resultado.status === "OK" || resultado.success || resultado.statusText === "OK") {
                    await getReglas();
                    await Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: "Regla eliminada con éxito.",
                        showConfirmButton: false,
                        timer: 1500,
                        customClass: { popup: 'nova-swal-popup' }
                    });
                } else {
                    throw new Error(resultado.message || 'Error al eliminar');
                }
            } catch (error) {
                console.error('Error al eliminar regla:', error);
                await Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: "Error al eliminar la regla.",
                    text: error.message || "Por favor, intenta nuevamente.",
                    showConfirmButton: false,
                    timer: 2000,
                    customClass: { popup: 'nova-swal-popup' }
                });
            } finally {
                setLoading(false);
            }
        }
    };

    const handleSaveRegla = async (formData) => {
        // formData viene del modal con: Titulo, Regla, Porcentaje, VigenciaInicio, VigenciaFin, Estatus
        setModalLoading(true);
        try {
            // Prepara payload para API
            const payload = {
                IdRegla: reglaEdit?.idRegla || 0,
                Titulo: formData.Titulo,
                Regla: formData.Regla,
                Porcentaje: parseFloat(formData.Porcentaje), // espera 5.5 por ejemplo
                VigenciaInicio: formData.VigenciaInicio, // yyyy-mm-dd o Date string
                VigenciaFin: formData.VigenciaFin,
                Estatus: formData.Estatus
            };

            let resultado;
            if (reglaEdit?.idRegla) {
                resultado = await vscService.putEditaReglaDescuento(payload); // debes implementar
            } else {
                resultado = await vscService.postInsertaReglaDescuento(payload); // debes implementar
            }

            if (resultado.status === "OK" || resultado.success || resultado.statusText === "OK") {
                await getReglas();
                setShowModal(false);
                setReglaEdit(null);
                await Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: reglaEdit?.idRegla ? "Regla actualizada con éxito." : "Regla creada con éxito.",
                    showConfirmButton: false,
                    timer: 1500,
                    customClass: { popup: 'nova-swal-popup' }
                });
            } else {
                throw new Error(resultado.message || 'Error en la operación');
            }
        } catch (error) {
            console.error('Error al guardar regla:', error);
            await Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Error al guardar la regla.",
                text: error.message || "Por favor, intenta nuevamente.",
                showConfirmButton: false,
                timer: 2000,
                customClass: { popup: 'nova-swal-popup' }
            });
        } finally {
            setModalLoading(false);
        }
    };

    return (
        <div className="nova-dashboard-balanced">
            <div className="nova-page-header">
                <h3 className="nova-page-title">Reglas de Descuento</h3>
                <div className="nova-header-actions-right">
                    <button 
                        className="nova-btn-primary"
                        onClick={handleAddNew}
                    >
                        <FaPlus className="me-2" />
                        Agregar Nueva Regla
                    </button>
                </div>
            </div>

            <div className="nova-data-table-container">
                <DataTable
                    columns={columns}
                    data={filteredItems}
                    customStyles={customStyles}
                    className="nova-react-datatable"
                    pagination
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[10, 25, 50]}
                    paginationComponentOptions={paginationComponentOptions}
                    progressPending={loading}
                    progressComponent={
                        <div className="nova-grid-loading">
                            <Spinner animation="border" role="status" />
                            <p>Cargando reglas...</p>
                        </div>
                    }
                    subHeader
                    subHeaderComponent={subHeaderComponent}
                    noDataComponent={<NoDataComponent />}
                    highlightOnHover
                    striped
                    responsive
                    fixedHeader
                    fixedHeaderScrollHeight="700px"
                    persistTableHead
                />
            </div>

            <ReglaModal
                show={showModal}
                onHide={() => { setShowModal(false); setReglaEdit(null); }}
                regla={reglaEdit}
                estatusOptions={estatusOptions}
                onSave={handleSaveRegla}
                loading={modalLoading}
            />

            <Tooltip id="edit-tooltip" place="top" />
            <Tooltip id="delete-tooltip" place="top" />
        </div>
    );
};

export default ReglasDescuento;
